import { Navigate, createBrowserRouter } from "react-router-dom";
import Landing from "../pages/Landing";
import Contact from "../pages/Contact";

export const Paths = {
  Contact: "/contact",
};

export const router = () => {
  let routes = [{
    path: "/",
    children: [
      {
        path: "/",
        element: <Landing />,
      },
      {
        path: "/:section",
        element: <Landing />,
      },
      {
        path: Paths.Contact,
        element: <Contact />
      },
      {
        path: "*",
        element: <Navigate to="/" />,
      },
    ],
  }];
  return createBrowserRouter(routes);
};
